// extracted by mini-css-extract-plugin
export default {"pageLayout":"PageLayout-module__pageLayout--fDuZk","contentWrapper":"PageLayout-module__contentWrapper--9T9MR","footerWrapper":"PageLayout-module__footerWrapper--qEJcV"};